import ApiService from "../ApiService";
import {isAuditorReadOnlyRole, isSuperAdminRole} from "./authUtil";
const {getRegion} = require("./common");
const {clinicianIdFromRefreshAuth} = require("./authUtil");
const ignoredKeys = ['createDateTime', 'kitId'];

export async function validClinicianLicenseStates() {
    try {
        const id = await clinicianIdFromRefreshAuth();
        const res = await ApiService.getValidLicenseStates();
        const data = res?.data ?? [];
        return data;
    } catch (err) {
        console.error(`Error getting valid clinician license states: ${err}`);
        throw err;
    }
}

export function checkForInvalidState(rowData, invalidStates) {
    if(rowData && invalidStates){
        const {user} = rowData;
        return invalidStates.indexOf(getRegion(user)) !== -1;
    }
    return true;
}

export function hideRelevantInfo(patientData, invalidStates) {
    if(isSuperAdminRole() || isAuditorReadOnlyRole()){
        return  patientData;
    }
    if(patientData && patientData.length && invalidStates && invalidStates.length) {
        return patientData.map(patient => {
            if(invalidStates.indexOf(getRegion(patient.user)) !== -1){
                modifyPatientData(patient);
                patient.disableAction = true;
                return patient;
            } else {
                return patient;
            }
        });
    }
    return patientData;
}

export function modifyPatientData(patient, invalidStates){
    for(let key in patient) {
        if(typeof(patient[key]) === 'object') {
            modifyPatientData(patient[key], invalidStates);
        } else if(ignoredKeys.indexOf(key) === -1){
            patient[key] = 'XXXXXX';           
        }
    }
    return patient;
}

// module.exports = {
//     checkForInvalidState,
//     hideRelevantInfo,
//     validClinicianLicenseStates
// }